import React from'react';

class ErrorBoundary extends React.Component {
 constructor(props) {
 super(props);
 this.state = { hasError: false, error: null, errorInfo: null };
 }

 static getDerivedStateFromError(_error) {
 // Update state so the next render will show the fallback UI
 return { hasError: true };
 }

 componentDidCatch(error, errorInfo) {
 // Log error details for debugging
 console.error('ErrorBoundary caught an error:', error, errorInfo);
 this.setState({
 error: error,
 errorInfo: errorInfo
 });

 // Log to console for mobile debugging
 if (typeof window !=='undefined') {
 console.error('Error details:', {
 message: error?.message,
 stack: error?.stack,
 componentStack: errorInfo?.componentStack,
 userAgent: navigator.userAgent,
 isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
 });
 }
 }

 handleReload = () => {
 // Clear service worker cache and reload
 if ('serviceWorker'in navigator &&'caches'in window) {
 caches.keys().then((names) => {
 names.forEach((name) => {
 caches.delete(name);
 });
 });
 }
 window.location.reload();
 };

 handleClearCache = () => {
 // Clear all storage and reload
 try {
 localStorage.clear();
 sessionStorage.clear();
 if ('serviceWorker'in navigator) {
 navigator.serviceWorker.getRegistrations().then((registrations) => {
 registrations.forEach((registration) => {
 registration.unregister();
 });
 });
 }
 if ('caches'in window) {
 caches.keys().then((names) => {
 names.forEach((name) => {
 caches.delete(name);
 });
 });
 }
 window.location.reload();
 } catch (error) {
 console.error('Error clearing cache:', error);
 window.location.reload();
 }
 };

 render() {
 // Error UI removed - errors are still caught and logged, but no error page is shown
 if (this.state.hasError) {
 // Just render children normally - error is already logged in componentDidCatch
 return this.props.children;
 }

 return this.props.children;
 }
}

export default ErrorBoundary;



